import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SyllabusService } from '@examdojo/category/v2';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { distinctUntilChanged, EMPTY, filter, map, switchMap, tap } from 'rxjs';
import { UserQuery } from '@examdojo/user';

@Injectable()
export class FetchCoursesOnProgramChangeService {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly syllabusService: SyllabusService,
  ) {
    this.userQuery.active$
      .pipe(
        map((user) => user?.program),
        filter(Boolean),
        distinctUntilChanged(),
        tap(() => this.syllabusService.resetCourses()),
        switchMap((program) => this.syllabusService.fetchCourses(program)),
        this.errorHandlerService.catchHttpErrors(() => EMPTY),
      )
      .pipe(takeUntilDestroyed())
      .subscribe();
  }
}
